import {FC, ChangeEvent, useState, useContext, useEffect} from 'react';
import {useHistory} from 'react-router';
import {Typography, Box, Grid, Container} from "@mui/material";
import {useLangContext} from '../../../shared/features/Language';
import {ImageContext} from "../../../shared/tools/image/imageContext";
import getCroppedImg from "../../../shared/tools/image/crop-utils";
import {CustomButton} from "../../../shared/components/Buttons/CustomButton";
import {CropComponent} from "../../art/components/CropComponent";
import {ItsClearComponent} from "../../art/components/ImageUploadView/itsClear";
import {ItsClearComponent2} from "../../art/components/ImageUploadView/itsClear2";
import '../../art/components/ImageUploadView/imageUploadComponent.scss';

import imgSrcBad from "shared/assets/img/example-src-bad.webp";
import imgArtBad from "shared/assets/img/example-art-bad.webp";
import imgSrcGood from "shared/assets/img/example-src.webp";
import imgArtGood from "shared/assets/img/example-art.webp";
import imgSrcBad2 from "shared/assets/img/example-src-bad-2.webp";
import imgArtBad2 from "shared/assets/img/example-art-bad-2.webp";
import imgSrcGood2 from "shared/assets/img/example-src-2.webp";
import imgArtGood2 from "shared/assets/img/example-art-2.webp";


export const DemoView: FC = () => {
  const {setCroppedImage, setCroppedImage2, setLoadingStatus, imageUrl, setImageUrl, croppedAreaPixels, setCroppedAreaPixels} = useContext(ImageContext);
  const [step, setStep] = useState(1);
  const {textData} = useLangContext();
  const history = useHistory();

  const preloadImages = [imgSrcBad, imgArtBad, imgSrcGood, imgArtGood, imgSrcBad2, imgArtBad2, imgSrcGood2, imgArtGood2];

  const handleSelectFile = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files && event.target.files[0];
    if (file) {
      setImageUrl(window.URL.createObjectURL(file));
    }
  }

  const handleSaveCroppedImage = async () => {
    setLoadingStatus(true);

    try {
      const croppedImage = await getCroppedImg(
        imageUrl,
        croppedAreaPixels
      );
      setCroppedImage(croppedImage as string);

      getCroppedImg(
        imageUrl,
        {
          height: Math.floor(croppedAreaPixels.height * 0.9),
          width: Math.floor(croppedAreaPixels.width * 0.9),
          x: Math.floor(croppedAreaPixels.x + croppedAreaPixels.width * 0.05),
          y: Math.floor(croppedAreaPixels.y + croppedAreaPixels.height * 0.05),
        }
      ).then(result => {
        setCroppedImage2(result);
        setTimeout( () => {history.push('/demo/art')}, 1000);
      });

    } catch (e) {
      console.error(e);
    }

  }

  useEffect(() => {
    preloadImages.forEach(image => {
      const img = new Image();
      img.src = image;
    });
  }, []);

  return (
    <Box sx={{width: '100%'}}>
      {!imageUrl ? (
        <>
          {(step === 1) && (
            <Box sx={{
              textAlign: 'center',
            }} className='upload-box'>
              <Typography
                variant='body2'
                sx={{
                  marginBottom: {lg: '50px', xs: '10px'},
                }}
              >{textData.motivationLoadImage}</Typography>
              <CustomButton
                width={{lg: '400px', xs: '320px'}}
                onClick={() => {
                  setStep(2)
                }}>
                {textData.buttonCaptionLoad}
              </CustomButton>
              <Typography
                variant='subtitle2'
                sx={{
                  marginTop: {lg: '50px', xs: '10px'},
                }}
              >
                {textData.noteSizeLimit}
              </Typography>
            </Box>
          )}

          {(step === 2) && (
            <Container
              sx={{
                height: '100%',
                maxWidth: {lg: '1200px', xs: '980px'},
                marginInline: 'auto',
              }}
            >
              <Box sx={{
                textAlign: 'center',
              }}>
                <ItsClearComponent/>
                <Grid container
                      sx={{
                        gap: '50px',
                        justifyContent: 'center',
                        marginTop: { lg: '20px', xs: '10px' },
                      }}
                >
                  <Grid item>
                    <CustomButton
                      width={{lg: '300px', xs: '200px'}}
                      onClick={() => {
                        setStep(3)
                      }}
                    >{textData.buttonCaptionItsClear}</CustomButton>
                  </Grid>
                </Grid>

              </Box>
            </Container>
          )}

          {(step === 3) && (
            <Container
              sx={{
                height: '100%',
                maxWidth: {lg: '1200px', xs: '980px'},
                marginInline: 'auto',
              }}
            >
              <Box sx={{
                textAlign: 'center',
              }}>
                <ItsClearComponent2/>
                <Grid container
                      sx={{
                        gap: '50px',
                        justifyContent: 'center',
                        marginTop: { lg: '20px', xs: '10px' }
                      }}
                >
                  <Grid item>
                    <CustomButton label width={{lg: '300px', xs: '200px'}}>
                      {textData.buttonCaptionItsClear}
                      <input hidden accept="image/*" multiple type="file" onChange={handleSelectFile}/>
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          )}
        </>
      ) : (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '30px'
        }}>
          <Typography
            variant='body2'
            sx={{
              textAlign: 'center',
              marginTop: {lg: '20px', xs: '0px' },
            }}
          >{textData.motivationSelectImageZone}</Typography>
          <CropComponent
            setCroppedAreaPixels={setCroppedAreaPixels}
            imageUrl={imageUrl}
            handleSelectFile={handleSelectFile}
          />
          <Grid container
                sx={{
                  gap: '20px',
                  justifyContent: 'center'
                }}
          >
            <Grid item>
              <CustomButton
                color='secondary'
                width={{ lg: '250px', xs: '150px' }}
                onClick={() => {
                  setImageUrl('')
                }}
              >{textData.buttonCaptionBack}</CustomButton>
            </Grid>
            <Grid item>
              <CustomButton
                width={{ lg: '250px', xs: '150px' }}
                onClick={handleSaveCroppedImage}
              >{textData.buttonCaptionNext}</CustomButton>
            </Grid>
          </Grid>
        </Box>
      )}

    </Box>
  )
}